/* CTA de la landing de Drenaje Linfatico.

   POR QUE ESTA REESCRITO (2026-08-09)
   La version anterior intentaba abrir el formulario de Releasit con un MouseEvent
   sintetico y, si lo encontraba, TERMINABA AHI. Dos problemas medidos en la pagina
   publicada:
     1. Releasit inyecta su boton por JavaScript: no esta en el HTML servido. Si el
        cliente toca un CTA antes de que la app cargue, no habia nada que pulsar.
     2. Cuando si existe, un click sintetico (isTrusted:false) puede ser ignorado.
   En los dos casos el cliente tocaba y NO PASABA NADA. Ese es el peor fallo posible
   en una landing COD: el que toca es el que iba a comprar.

   AHORA: primero SIEMPRE se mueve la pagina hasta la zona de compra —eso pasa el
   100% de las veces y da respuesta inmediata— y despues, aparte, se intenta abrir el
   formulario. Si la app no responde, el cliente ya esta mirando el boton de compra.

   El salto es INSTANTANEO a proposito: el tema trae html{scroll-behavior:smooth} y el
   body tiene overflow:hidden auto, asi que un scroll animado sobre una pagina larga
   tarda segundos en arrancar (medido en el G58: 2.400-2.800 ms). */
(function () {
  if (window.__dmJump) return;
  window.__dmJump = 1;

  var SEL_RSI = '#_rsi-buy-now-button,[id*="rsi-buy-now"],[class*="_rsi-buy-now"],' +
                '[data-rsi-buy-now],.rsi-buy-now-button';

  function boton() {
    var lista = document.querySelectorAll(SEL_RSI);
    for (var i = 0; i < lista.length; i++) {
      var b = lista[i];
      // Releasit deja botones ocultos en el DOM; solo sirve el que se ve.
      if (b.offsetParent !== null || b.getClientRects().length) return b;
    }
    return lista[0] || null;
  }

  function destino() {
    return boton() ||
           document.querySelector('form[action*="/cart/add"]') ||
           document.querySelector('.product__info-wrapper');
  }

  function saltar() {
    var t = destino();
    if (!t) return;
    var y = t.getBoundingClientRect().top + window.pageYOffset - 120;
    if (y < 0) y = 0;
    var h = document.documentElement, prev = h.style.scrollBehavior;
    h.style.scrollBehavior = 'auto';
    try { window.scrollTo({ top: y, behavior: 'instant' }); }
    catch (e) { window.scrollTo(0, y); }
    h.style.scrollBehavior = prev;
  }

  // Cuenta los campos visibles del formulario. Es la unica forma fiable de saber si
  // Releasit abrio de verdad: su boton no expone estado y su HTML lo inyecta la app.
  function campos() {
    var l = document.querySelectorAll(
      'input[type="text"],input[type="tel"],input[type="email"],textarea,' +
      '[id*="rsi"] input,[class*="_rsi"] input');
    var n = 0;
    for (var i = 0; i < l.length; i++) if (l[i].offsetParent !== null) n++;
    return n;
  }

  /* OJO — AQUI HUBO UN BUG CARO (corregido 2026-08-12).
     La version anterior hacia b.click() Y ADEMAS dispatchEvent('click') sobre el mismo
     boton: DOS clicks seguidos. El boton de Releasit ALTERNA el formulario, asi que el
     primer click lo abria y el segundo lo cerraba en el mismo instante. El cliente veia
     un parpadeo y nada mas.
     Peor aun para el embudo: Releasit dispara InitiateCheckout al ABRIR, asi que el
     pixel contaba "pago iniciado" en un formulario que se cerraba solo. Encaja con el
     dia de 15 pagos iniciados y 1 compra.
     Ahora se dispara UN solo click y solo se prueba el segundo metodo si, pasados
     300 ms, no aparecio ningun campo nuevo. */
  function abrir(intento) {
    var b = boton();
    if (!b) {
      if ((intento || 0) < 5) setTimeout(function () { abrir((intento || 0) + 1); }, 200);
      return;
    }
    var antes = campos();
    try { b.click(); } catch (e) {}
    setTimeout(function () {
      if (campos() > antes) return;            // ya abrio: no se toca nada mas
      try {
        b.dispatchEvent(new MouseEvent('click',
          { bubbles: true, cancelable: true, view: window }));
      } catch (e) {}
    }, 300);
  }

  /* Video a peticion. Antes iban con autoplay: en cuanto entraban en pantalla el
     telefono empezaba a bajar 1,5-1,8 MB cada uno, cinco MB en total, justo mientras
     el cliente hace scroll por 4G. Ahora se ve la portada con un boton de play y solo
     se descarga el que se toca. */
  function reproducir(v) {
    if (!v) return;
    v.setAttribute('controls', '');
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;

    var play = e.target.closest('[data-dm-play]');
    if (play) {
      e.preventDefault();
      play.classList.add('dm-v--on');
      reproducir(play.querySelector('video'));
      return;
    }

    var b = e.target.closest('[data-dm-jump]');
    if (!b) return;
    e.preventDefault();
    saltar();     // respuesta visible siempre
    abrir(0);     // y ademas se intenta abrir el formulario
  }, true);
})();
